import { IIconProps } from '~/types';
const JpyFlag = (props: IIconProps) => (
  <svg
    width={28}
    height={20}
    viewBox="0 0 28 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={0.25}
      y={0.25}
      width={27.5}
      height={19.5}
      rx={1.75}
      fill="white"
      stroke="#F5F5F5"
      strokeWidth={0.5}
    />
    <mask
      id="mask0_1014_3401"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={28}
      height={20}
    >
      <rect
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={1.75}
        fill="white"
        stroke="white"
        strokeWidth={0.5}
      />
    </mask>
    <g mask="url(#mask0_1014_3401)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 16C17.3137 16 20 13.3137 20 10C20 6.68629 17.3137 4 14 4C10.6863 4 8 6.68629 8 10C8 13.3137 10.6863 16 14 16Z"
        fill="url(#paint0_linear_1014_3401)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1014_3401"
        x1={8}
        y1={4}
        x2={8}
        y2={16}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D81441" />
        <stop offset={1} stopColor="#BB0831" />
      </linearGradient>
    </defs>
  </svg>
);
export default JpyFlag;
